<template>
    <div class="vue-filter-option">
        <div class="form-type-checkbox">
            <input :id="this.groupId + '-' + filter.label | cleanLabel" type="checkbox" :checked="active" @click="handleClick">
            <label :for="this.groupId + '-' + filter.label | cleanLabel">{{ filter.label }}</label>
        </div>
    </div>
</template>

<script>
import InputFormatter from "../../mixins/InputFormatter";

export default {
    name: "FilterOption",

    mixins: [InputFormatter],

    props: {
        filter: {
            type: Object,
            required: true
        },

        activeFilters: {
            type: Array
        },

        groupId: {
            type: String,
        }
    },

  mounted() {

    const urlParams = new URLSearchParams(window.location.search);
    const param = urlParams.get('vehicleGroupId');

    if (param && this.filter.id == param) {
      this.$emit('clicked', this.filter);
    }

  },
    computed: {
        active() {
            return lodash.includes(this.activeFilters, this.filter);
        }
    },

    methods: {
        handleClick() {
            this.$emit('clicked', this.filter);
        }
    }
}
</script>
